import type { ClassValue } from "clsx";

import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export type ClassName = ClassValue;

export function cn(...classes: ClassName[]): string {
  return twMerge(clsx(...classes));
}
